import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import {routes} from './routes.js';
import Article from './components/NewArticle.vue';
import Navbar from './components/Navbar.vue';
import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";
import "firebase/auth";

/*var firebaseConfig = {
    apiKey: "AIzaSyCYDI2kxTXE6fXavSz838TSG_1TEnfqyD8",
    authDomain: "csoda-a6bbc.firebaseapp.com",
    databaseURL: "https://csoda-a6bbc.firebaseio.com",
    projectId: "csoda-a6bbc",
    storageBucket: "csoda-a6bbc.appspot.com",
    messagingSenderId: "13464711115",
    appId: "1:13464711115:web:8557e3908cf41a315ed04e"
};*/

var firebaseConfig = {
    apiKey: "AIzaSyAzEcZN0_6Nf0wcFKzQrdHwUQ76hn3WsRU",
    authDomain: "csoda-7daec.firebaseapp.com",
    databaseURL: " https://csoda-7daec-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "csoda-7daec",
    storageBucket: "csoda-7daec.appspot.com",
    messagingSenderId: "330544783020",
    appId: "1:330544783020:web:8e09c7d97944b79793c909"
}

firebase.initializeApp(firebaseConfig);

Vue.use(VueRouter);
//Vue.use(firebase);

const router = new VueRouter({
	routes,
	mode: 'history'
});

new Vue({
	el: '#app',
	router,
	render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js